import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { dateTimeToTime } from 'utils/datetime'
import { thumbnailSelector } from 'features/patient-file-thumbnail/thumbnailSlice'
import { FileContext } from 'features/share-details/Details'
import ThumbnailComponent from 'components/Thumbnail'

const Thumbnail = ({ data, handleSelectFile, isLoading, handleClick }) => {
    const img = useSelector(state => thumbnailSelector.selectById(state, data.thumbnailId))
    const { selectable } = useContext(FileContext)
    const isSelected = selectable.selectedFiles.includes(data.fileId)

    return (
        <ThumbnailComponent
            onSelect={handleSelectFile}
            isLoading={isLoading && data.thumbnailId && !img}
            isSelected={isSelected}
            id={data.fileId}
            time={dateTimeToTime(data.updatedDateTime)}
            fileType={data.thumbnailId ? data.fileType : false}
            url={img?.downloadUrl}
            onClick={() => handleClick(data.fileId)}
        />
    )
}

export default Thumbnail
